/* eslint-disable import/prefer-default-export */
import moment from 'moment';

export const IsExpired = (exp) => moment().unix() > exp;
